import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import {
	setInitialLoginState,
	juniorLogin,
	changeLoginId,
	changePin,
	setUserType,
} from '../../../redux/userAuthentication/userAuth.actions';
import { setErrorPanel } from '../../../redux/utilities/utils.actions';
import FootNote from '../sharedComponents/footNote';
import '../userAuthenticationStyles.css';
import { trimText, validUserName } from '../../../utils/commonFunctions';
import Config from '../../../config/Config';
import NameField from '../sharedComponents/nameField';
import PinField from '../sharedComponents/pinField';
import Loader from '../../../utils/Loader';
import './juniorStyles.css';

const ParentSignUp = ({
	error: { panelClass, panelMsg },
	loginId,
	setErrorPanel,
	pin,
	createUser,
	changeLoginId,
	changePin,
	setUserType,
	userType,
}) => {
	useEffect(() => {
		setErrorPanel({
			errorPanel: {
				panelClass: '',
				panelMsg: '',
			},
		});
		Loader.hide();
	}, [setErrorPanel]);

	useEffect(() => {
		navigator.clipboard.readText().then((clipText) => {
			let words = clipText.split(' ');

			let usernameIndex = words.findIndex((word) => word === 'username:');
			let pinIndex = words.findIndex((word) => word === 'pin:');
			if (usernameIndex > -1 && pinIndex > -1) {
				let username = words[usernameIndex + 1];
				let pin = words[pinIndex + 1];
				changeLoginId(username);
				changePin(pin);
			}
		});
	}, [changeLoginId, changePin]);

	const validateName = () => {
		loginId = trimText(loginId);
		let panelMsg = validUserName(loginId);
		localStorage.setItem('login_id', loginId);

		if (panelMsg.length > 0) {
			setErrorPanel({
				panelClass: 'alert alert-danger',
				panelMsg,
			});
			return false;
		}
		if (!loginId.trim()) {
			setErrorPanel({
				panelClass: 'alert alert-danger',
				panelMsg: 'Please enter Username',
			});
		} else if (pin === '') {
			setErrorPanel({
				panelClass: 'alert alert-danger',
				panelMsg: 'Please enter pin',
			});
		} else createUser({ login_id: loginId, pin, is_kid: true });
	};

	return (
		<div class="login_wrapper">
			<div class="login_box">
				<div class="login_form">
					<div class="login_form_inner">
						<ul class="login_tab">
							<li>
								<img src={Config.ASSETSPATH + 'img/STEP_logo.png'} alt="STEPlogo" />
							</li>
						</ul>
						<div className="message_box">
							<div className={panelClass}>{panelMsg}</div>
						</div>
						<form action="" method="POST">
							<div class="form-group">
								<NameField placeholder="Enter Username" />
							</div>
							<div class="form-group">
								<PinField class="input-text" />
							</div>

							<div class="form-group">
								<button
									aria-label="login"
									id="loginBtn"
									type="button"
									className="btn-md btn-theme btn-block"
									onClick={validateName}
								>
									Log in
								</button>
							</div>
						</form>
					</div>
					<div class="or_options text-center">
						<div class="or_text">
							<span></span>
						</div>
						<FootNote userActivity="Log In" />
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { loginId, success, pin, userType } = state.rootReducer.loginDetails;
	return {
		loginId,
		error: state.rootReducer.utils.errorPanel,
		success,
		pin,
		userType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setErrorPanel: (errorText) => dispatch(setErrorPanel(errorText)),
		updateState: (value) => dispatch(setInitialLoginState(value)),
		createUser: (val) => dispatch(juniorLogin(val)),
		changeLoginId: (name) => dispatch(changeLoginId(name)),
		changePin: (pin) => dispatch(changePin(pin)),
		setUserType: (type) => dispatch(setUserType(type)),
	};
};

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(ParentSignUp),
);
